import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OAuth2Guard } from './services/auth.guard';
import { RoleUnauthorizedComponent } from './partial/role-unauthorize/role-unauthorize.component';
import { AnalyticsComponent } from './partial/analytics/analytics.component';

const routes: Routes = [
  { path: 'claimOffice-web', redirectTo: 'process-claims', pathMatch: 'full' },

  {
    path: 'process-claims',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import('./partial/process-claims/process-claims.module').then(
        (mod) => mod.ProcessClaimsModule
      ),
  },
  {
    path: 'process-claims/register-death',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import(
        './partial/process-claims/register-death/register-death.module'
      ).then((mod) => mod.RegisterDeathModule),
  },
  {
    path: 'process-claims/claim-review',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import('./partial/process-claims/claim-review/claim-review.module').then(
        (mod) => mod.ClaimReviewModule
      ),
  },
  {
    path: 'process-claims/assessment',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import('./partial/process-claims/assessment/assessment.module').then(
        (mod) => mod.AssessmentModule
      ),
  },
  {
    path: 'process-claims/decision-settlements',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import(
        './partial/process-claims/decision-and-settlements/decision-and-settlements.module'
      ).then((mod) => mod.DecisionAndSettlementsModule),
  },
  {
    path: 'process-claims/accidental-disability-dismemberment',
    canActivate: [OAuth2Guard],
    loadChildren: () =>
      import(
        './partial/process-claims/accidental-disability-dismemberment/accidental-disability-dismemberment.module'
      ).then((mod) => mod.AccidentalDisabilityDismembermentModule),
  },
  {
    path: 'analytics',
    component: AnalyticsComponent,
  },
  {
    path: 'unauthorize',
    component: RoleUnauthorizedComponent,
  },
  { path: '**', redirectTo: 'process-claims' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
